// Modal para escolher entre começar em branco ou usar um template de sistema.
// Isolado como componente próprio para facilitar reversão: se retirar, basta
// remover o uso em Templates/index.jsx.

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Spinner,
} from "reactstrap";
import { getMockSystemTemplates } from "./mockSystemTemplates";

function ModalPickTemplate({
  isOpen,
  toggle,
  type,
  route = "/html-editor",
  extraState = {},
  jwt,
}) {
  const navigate = useNavigate();
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!isOpen || !type) return;
    setLoading(true);
    getMockSystemTemplates({ jwt, type })
      .then((list) => setTemplates(list))
      .catch(() => setTemplates([]))
      .finally(() => setLoading(false));
  }, [isOpen, type, jwt]);

  const goToEditor = (seedTemplate) => {
    navigate(route, {
      state: {
        ...extraState,
        type_template: type,
        editMode: false,
        seedTemplate: seedTemplate || null,
      },
    });
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="xl" centered>
      <ModalHeader toggle={toggle}>
        Começar novo template {type === "email" ? "de Email" : "Web"}
      </ModalHeader>
      <ModalBody>
        <div
          style={{
            display: "flex",
            gap: 24,
            padding: 16,
            border: "2px dashed #d0d5dd",
            borderRadius: 8,
            marginBottom: 24,
            alignItems: "center",
            cursor: "pointer",
            transition: "background 0.15s",
          }}
          onClick={() => goToEditor(null)}
          onMouseEnter={(e) =>
            (e.currentTarget.style.background = "#f8f9fa")
          }
          onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
        >
          <div
            style={{
              width: 64,
              height: 64,
              borderRadius: "50%",
              background: "#556ee6",
              color: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 28,
              flexShrink: 0,
            }}
          >
            <i className="fa fa-plus" />
          </div>
          <div>
            <h5 style={{ margin: 0 }}>Começar em branco</h5>
            <p style={{ margin: 0, color: "#666", fontSize: 14 }}>
              Abre o editor vazio para você criar do zero.
            </p>
          </div>
        </div>

        <h6 style={{ marginBottom: 16, color: "#333" }}>
          Ou escolha um template pronto para customizar:
        </h6>

        {loading && (
          <div style={{ textAlign: "center", padding: 32 }}>
            <Spinner size="sm" /> Carregando templates...
          </div>
        )}

        {!loading && templates.length === 0 && (
          <div style={{ textAlign: "center", padding: 32, color: "#888" }}>
            Nenhum template de sistema disponível.
          </div>
        )}

        {!loading && templates.length > 0 && (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))",
              gap: 16,
            }}
          >
            {templates.map((tpl) => (
              <div
                key={tpl.id}
                onClick={() => goToEditor(tpl)}
                style={{
                  border: "1px solid #e0e0e0",
                  borderRadius: 8,
                  overflow: "hidden",
                  cursor: "pointer",
                  transition: "transform 0.15s, box-shadow 0.15s",
                  background: "#fff",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow =
                    "0 4px 16px rgba(0,0,0,0.12)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                <div
                  style={{
                    height: 180,
                    overflow: "hidden",
                    background: "#f8f9fa",
                    position: "relative",
                  }}
                >
                  <iframe
                    title={tpl.name}
                    srcDoc={tpl.htmlString}
                    style={{
                      width: "200%",
                      height: "360px",
                      transform: "scale(0.5)",
                      transformOrigin: "top left",
                      border: 0,
                      pointerEvents: "none",
                    }}
                  />
                </div>
                <div style={{ padding: 12 }}>
                  <div style={{ fontWeight: 500 }}>{tpl.name}</div>
                </div>
              </div>
            ))}
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Cancelar
        </Button>
      </ModalFooter>
    </Modal>
  );
}

const mapStateToProps = (state) => ({
  jwt: state?.global_user_data?.data?.token,
});

export default connect(mapStateToProps)(ModalPickTemplate);
